module.exports = __webpack_public_path__ + "static/img/synapse-icon.7acef9be.svg";